export default class GraphPopup {
    constructor() {
        this.mouseOverElm = null;
        this.routeUrl = null;
        this.popupDataCache = {};
        this.mouseOver = this.mouseOver.bind(this);
        this.mouseOut = this.mouseOut.bind(this);
    }

    init(routeUrl) {
        this.routeUrl = routeUrl;
        $(document).on('mouseover', '[data-graph-popup]', this.mouseOver)
            .on('mouseout', '[data-graph-popup]', this.mouseOut);

    }

    mouseOver(e) {
        let $e = $(e.currentTarget);
        let type = $e.data('graph-popup');
        let languageId = $e.data('graph-popup-language-id') ?? 0;
        let template = $('.popover-template')[0].outerHTML;
        this.mouseOverElm = $e;

        if (this.popupDataCache[type + languageId]) {
            $e.popover({
                template: template,
                html: true,
                sanitize: false,
                content: this.popupDataCache[type + languageId],
                trigger: 'manual',
            }).popover('show');
        } else {
            $.ajax({
                url: this.routeUrl,
                method: 'GET',
                data: {
                    type: type,
                    languageId: languageId,
                },
                success: (response) => {
                    this.popupDataCache[type + languageId] = response.html;
                    if(this.mouseOverElm === $e) {
                        $e.popover({
                            template: template,
                            html: true,
                            sanitize: false,
                            content: response.html,
                            trigger: 'manual',
                        }).popover('show');
                    }
                }
            })
        }
    }

    mouseOut(e) {
        let $e = $(e.currentTarget);
        $e.popover('hide');
        this.mouseOverElm = null;
    }


}
